/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [{
    url: "/",
    name: "Inicio",
    slug: "home",
    icon: "HomeIcon",
  },

  {
    url: "/ordenes",
    name: "Envíos M1",
    slug: "ordenes",
    icon: "PackageIcon",
    submenu: [{
        url: '/ordenes/por-enviar',
        slug: 'ordenes-por-enviar',
        name: 'Por Enviar'
      },
      {
        url: '/ordenes/procesadas',
        slug: 'ordenes-procesadas',
        name: 'Procesadas'
      },
      {
        url: '/ordenes/invalidas',
        slug: 'ordenes-invalidas',
        name: 'Inválidas'
      },
      {
        url: '/ordenes/desestimadas',
        slug: 'ordenes-desestimadas',
        name: 'Desestimadas'
      }

    ]
  },

  {
    url: "/meli-flex",
    name: "Envíos Flex",
    slug: "meli-flex",
    icon: "ZapIcon",
    // La seccion se muestra solo si el merchant tiene Flex habilitado. Se filtra en
    // Main.vue leyendo `meli_flex_enabled` de GET /api/user.
    requiresFlex: true,
    submenu: [{
        url: '/meli-flex/configuracion',
        slug: 'flex-configuracion',
        name: 'Configuración'
      },
      {
        url: '/meli-flex/ordenes/por-enviar',
        slug: 'flex-ordenes-por-enviar',
        name: 'Por Enviar'
      },
      {
        url: '/meli-flex/ordenes/procesadas',
        slug: 'flex-ordenes-procesadas',
        name: 'Procesadas'
      },
      {
        url: '/meli-flex/ordenes/invalidas',
        slug: 'flex-ordenes-invalidas',
        name: 'Inválidas'
      },
      {
        url: '/meli-flex/ordenes/desestimadas',
        slug: 'flex-ordenes-desestimadas',
        name: 'Desestimadas'
      }
    ]
  },

  {
    url: '/conexiones',
    name: 'Conexiónes',
    slug: 'conexiones',
    icon: 'RadioIcon',
  },
  {
    url: '/catalogo',
    name: 'Catálogo',
    slug: 'catalogo',
    icon: 'SlidersIcon',
  },

  /*{
    url: "/cuenta",
    name: "Cuenta",
    slug: "cuenta",
    icon: "SlidersIcon",
  },*/


]
